import { faKey, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
//import AuthSocialButtons from 'components/common/AuthSocialButtons';
import { Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from 'providers/AuthProvider'
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

const SignInForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const auth = useAuth();
  const [loginError, setLoginError] = useState("");

  const [language, setLanguage] = useState(() => {
    const storedLanguage = localStorage.getItem('language');
    return storedLanguage === "en" || storedLanguage === "it"  // Add valid languages
      ? storedLanguage
      : "en"; // Default value
  });

  const [rememberMe, setRememberMe] = useState(localStorage.getItem("remember_me") === "true" ? true : false);

  //let from = location.state?.from?.pathname || "/";

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setRememberMe(checked);

  };

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const email = formData.get("email") as string;
    const password = formData.get("password") as string;
    //const remember_me = formData.get("remember-me") as string;

    auth.signin(email, password, rememberMe, (destination: string, error: string | null) => {
      // Send them back to the page they tried to visit when they were
      // redirected to the login page. Use { replace: true } so we don't create
      // another entry in the history stack for the login page.  This means that
      // when they get to the protected page and click the back button, they
      // won't end up back on the login page, which is also really nice for the
      // user experience.
      //console.log("Navigate to:" + from);

      if (error === null) {
        localStorage.setItem('language', language);
        i18n.changeLanguage(language);
        //navigate('/dashboard/home', { replace: true });
        navigate(destination, { replace: true });
      }
      else
        setLoginError(error);
    });
  }



  useEffect(() => {
    if (localStorage.getItem('remember_me') === "true")
      auth.autoSignin((destination: string, error: string | null) => {
        if (error === null) {
          i18n.changeLanguage(language);
          navigate(destination, { replace: true });
        }
        else
          setLoginError(error);
      });

  }, []);


  return (
    <>

      <div className="text-center mb-7">
        <h3 className="text-1000">{t("SignInForm.sign_in")}</h3>
        <p className="text-700">{t("SignInForm.sign_in_message")}</p>
      </div>
      {/* 
      <AuthSocialButtons title="Sign in" />
      <div className="position-relative">
        <hr className="bg-200 mt-5 mb-4" />
        <div className="divider-content-center">{t("SignInForm.or_use_email")}</div>
      </div>
    */}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="email">{t("SignInForm.email_address")}</Form.Label>
          <div className="form-icon-container">
            <Form.Control
              required
              id="email"
              type="email"
              name="email"
              className="form-icon-input"
              placeholder="name@example.com"
            />
            <FontAwesomeIcon icon={faUser} className="text-900 fs-9 form-icon" />
          </div>
        </Form.Group>
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="password">{t("SignInForm.password")}</Form.Label>
          <div className="form-icon-container">
            <Form.Control
              required
              id="password"
              type="password"
              name="password"
              className="form-icon-input"
              placeholder="Password"
            />
            <FontAwesomeIcon icon={faKey} className="text-900 fs-9 form-icon" />
          </div>
        </Form.Group>


        <Form.Group as={Row} className="mb-3 text-start">
          <Form.Label htmlFor="language">{t("SignInForm.language")}</Form.Label>


          <div className="form-icon-container">
            <Form.Select id="language" name="language" value={language} onChange={(e) => setLanguage(e.target.value)}>
              <option value="en">English</option>
              <option value="it">Italian</option>
            </Form.Select>
          </div>
        </Form.Group>


        <Row className="flex-between-center mb-7">
          <Col xs="auto">
            <Form.Check type="checkbox" className="mb-0">
              <Form.Check.Input
                type="checkbox"
                name="remember-me"
                id="remember-me"
                checked={rememberMe}
                onChange={handleCheckChange}
              />
              <Form.Check.Label htmlFor="remember-me" className="mb-0">
                {t("SignInForm.remember_me")}
              </Form.Check.Label>
            </Form.Check>
          </Col>
          <Col xs="auto">
            <Link
              to={`/forgot-password`}
              className="fs-9 fw-semi-bold"
            >
              {t("SignInForm.forgot_password")}
            </Link>
          </Col>
        </Row>
        <Button type="submit" variant="primary" className="w-100 mb-3">
          {t("SignInForm.button.sign_in")}
        </Button>
      </Form>

      {!!loginError && (
        <div className="text-center  mt-2">
          <h3 className="text-1000 text-danger ">{loginError}</h3>
        </div>)}


      {/* 
      <div className="text-center">
        <Link
          to={`/signup`}
          className="fs-9 fw-bold"
        >
          {t("SignInForm.button.create_account")}
        </Link>
      </div>
      */}
    </>
  );
};

export default SignInForm;
